import { useCallback, useState } from 'react';
import _ from '@lodash';

const useForm = (initialState, onSubmit) => {
	const [form, setForm] = useState(initialState);

	// Gives Value to Existing Item in Form
	const handleChange = useCallback((event, value) => {
		event.persist();
		setForm(form =>
			_.setIn(
				{ ...form },
				event.target.name,
				event.target.type === 'checkbox' ? event.target.checked : event.target.value || value
			)
		);
	}, []);

	//updates cred keys
	const handleKeyChange = useCallback((event, creds) => {
		const keys = creds || {};
		if (event) {
			event.persist();
			keys[event.target.name] = event.target.value;
		}
		setForm(form => _.setIn({ ...form }, 'keys', { ...form.keys, ...keys }));
	}, []);

	// Resets Form
	const resetForm = useCallback(() => {
		if (!_.isEqual(initialState, form)) {
			setForm(initialState);
		}
	}, [form, initialState]);

	// Creates New Item in Form
	const setInForm = useCallback((name, value) => {
		setForm(form => _.setIn(form, name, value));
	}, []);

	// Submits Form
	const handleSubmit = useCallback(
		event => {
			if (event) {
				event.preventDefault();
			}
			if (onSubmit) {
				onSubmit();
			}
		},
		[onSubmit]
	);

	return {
		form,
		handleChange,
		handleKeyChange,
		handleSubmit,
		resetForm,
		setForm,
		setInForm
	};
};

export default useForm;
